/** @format */

import { useState } from 'react';
import { useEffect } from 'react';

export const AppsIcon = props => {
  return (
    <svg
      width={props.width || 19}
      height={props.height || 20}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0.5H5V5.5H0V0.5Z" fill={props.color || '#ffffff'} />
      <path d="M0 7.5H5V12.5H0V7.5Z" fill={props.color || '#ffffff'} />
      <path d="M5 14.5H0V19.5H5V14.5Z" fill={props.color || '#ffffff'} />
      <path d="M7 0.5H12V5.5H7V0.5Z" fill={props.color || '#ffffff'} />
      <path d="M12 7.5H7V12.5H12V7.5Z" fill={props.color || '#ffffff'} />
      <path d="M7 14.5H12V19.5H7V14.5Z" fill={props.color || '#ffffff'} />
      <path d="M19 0.5H14V5.5H19V0.5Z" fill={props.color || '#ffffff'} />
      <path d="M14 7.5H19V12.5H14V7.5Z" fill={props.color || '#ffffff'} />
      <path d="M19 14.5H14V19.5H19V14.5Z" fill={props.color || '#ffffff'} />
    </svg>
  );
};

export const HomeIcon = props => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 19H9V13H15V19H18V10L12 5.5L6 10V19ZM4 21V9L12 3L20 9V21H13V15H11V21H4Z"
        fill={props.color || '#1F1F1F'}
      />
    </svg>
  );
};

export const ChevronRight = props => {
  return (
    <svg
      width={props.width || 8}
      height={props.height || 12}
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.99984 0L0.589844 1.41L5.16984 6L0.589844 10.59L1.99984 12L7.99984 6L1.99984 0Z"
        fill={props.color || '#000000'}
      />
    </svg>
  );
};

export const UploadIcon = props => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0209 4 18.55 4 18V16C4 15.7167 4.09583 15.4792 4.2875 15.2875C4.47917 15.0959 4.71667 15 5 15C5.28333 15 5.52083 15.0959 5.7125 15.2875C5.90417 15.4792 6 15.7167 6 16V18H18V16C18 15.7167 18.0958 15.4792 18.2875 15.2875C18.4792 15.0959 18.7167 15 19 15C19.2833 15 19.5208 15.0959 19.7125 15.2875C19.9042 15.4792 20 15.7167 20 16V18C20 18.55 19.8042 19.0209 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6ZM11 7.85005L9.125 9.72505C8.925 9.92505 8.6875 10.0209 8.4125 10.0125C8.1375 10.0042 7.9 9.90005 7.7 9.70005C7.51667 9.50005 7.42083 9.26672 7.4125 9.00005C7.40417 8.73338 7.5 8.50005 7.7 8.30005L11.3 4.70005C11.4 4.60005 11.5083 4.52922 11.625 4.48755C11.7417 4.44588 11.8667 4.42505 12 4.42505C12.1333 4.42505 12.2583 4.44588 12.375 4.48755C12.4917 4.52922 12.6 4.60005 12.7 4.70005L16.3 8.30005C16.5 8.50005 16.5958 8.73338 16.5875 9.00005C16.5792 9.26672 16.4833 9.50005 16.3 9.70005C16.1 9.90005 15.8625 10.0042 15.5875 10.0125C15.3125 10.0209 15.075 9.92505 14.875 9.72505L13 7.85005V15C13 15.2834 12.9042 15.5209 12.7125 15.7125C12.5208 15.9042 12.2833 16 12 16C11.7167 16 11.4792 15.9042 11.2875 15.7125C11.0958 15.5209 11 15.2834 11 15V7.85005Z"
        fill={props.color || '#1F1F1F'}
      />
    </svg>
  );
};

export const ExitIcon = props => {
  const { width = 21, height = 18, color = '#000000', ...rest } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M9.5 4L8.1 5.4L10.7 8H0.5V10H10.7L8.1 12.6L9.5 14L14.5 9L9.5 4ZM18.5 16H10.5V18H18.5C19.6 18 20.5 17.1 20.5 16V2C20.5 0.9 19.6 0 18.5 0H10.5V2H18.5V16Z"
        fill={color}
      />
    </svg>
  );
};

export const PersonIcon = props => {
  return (
    <svg
      width={props.width || 16}
      height={props.height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 10C5.33 10 0 11.34 0 14V15C0 15.55 0.45 16 1 16H15C15.55 16 16 15.55 16 15V14C16 11.34 10.67 10 8 10Z"
        fill={props.color || '#000000'}
      />
    </svg>
  );
};

export const DeleteIcon = props => {
  return (
    <svg
      width={props.width || 18}
      height={props.height || 18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 0C4.58579 0 4.25 0.335786 4.25 0.75C4.25 1.16421 4.58579 1.5 5 1.5H11C11.4142 1.5 11.75 1.16421 11.75 0.75C11.75 0.335786 11.4142 0 11 0H5Z"
        fill="black"
      />
      <path
        d="M6 7.25C6.41421 7.25 6.75 7.58579 6.75 8V13C6.75 13.4142 6.41421 13.75 6 13.75C5.58579 13.75 5.25 13.4142 5.25 13V8C5.25 7.58579 5.58579 7.25 6 7.25Z"
        fill="black"
      />
      <path
        d="M10.75 8C10.75 7.58579 10.4142 7.25 10 7.25C9.58579 7.25 9.25 7.58579 9.25 8V13C9.25 13.4142 9.58579 13.75 10 13.75C10.4142 13.75 10.75 13.4142 10.75 13V8Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 4C0.25 3.58579 0.585786 3.25 1 3.25H15C15.4142 3.25 15.75 3.58579 15.75 4C15.75 4.41421 15.4142 4.75 15 4.75H14.75V15C14.75 16.5192 13.5192 17.75 12 17.75H4C2.48079 17.75 1.25 16.5192 1.25 15V4.75H1C0.585786 4.75 0.25 4.41421 0.25 4ZM2.75 15V4.75H13.25V15C13.25 15.6908 12.6908 16.25 12 16.25H4C3.30921 16.25 2.75 15.6908 2.75 15Z"
        fill="black"
      />
    </svg>
  );
};

export const BackArrowIcon = props => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2359_41)">
        <path d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_2359_41">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CSSIcon = props => {
  const { className, width, height, style, ...rest } = props;
  return (
    <div
      className={`css-icon ${className || ''}`.trim()}
      style={{
        width: width || undefined,
        height: height || undefined,
        ...style
      }}
      {...rest}
    />
  );
};

export const SearchIcon = props => {
  return <CSSIcon className="search-icon" {...props} />;
};
export const GlobeIcon = props => {
  return <CSSIcon className="globe-icon" {...props} />;
};

export const GlobalIcon = props => {
  return <CSSIcon className="global-icon" {...props} />;
};

export const HelpIcon = props => {
  return <CSSIcon className="help-icon" {...props} />;
};
export const FilterIcon = props => {
  return <CSSIcon className="filter-icon" {...props} />;
};
export const ArrowDownIcon = props => {
  return <CSSIcon className="arrow-down-icon" {...props} />;
};
export const CrossIcon = props => {
  return <CSSIcon className="cross-icon" {...props} />;
};
export const CloseIcon = props => {
  return <CSSIcon className="close-icon" {...props} />;
};
export const TopicsIcon = props => {
  return <CSSIcon className="topics-icon" {...props} />;
};
export const TagsIcon = props => {
  return <CSSIcon className="tags-icon" {...props} />;
};
export const PlusIcon = props => {
  return <CSSIcon className="plus-icon" {...props} />;
};
export const ContentEditorIcon = props => {
  return <CSSIcon className="content-editor-icon" {...props} />;
};
export const ImageEditorIcon = props => {
  return <CSSIcon className="image-editor-icon" {...props} />;
};
export const ImageTextEditorIcon = props => {
  return <CSSIcon className="image-text-editor-icon" {...props} />;
};
export const VideoEditorIcon = props => {
  return <CSSIcon className="video-editor-icon" {...props} />;
};
export const SaleInfoIcon = props => {
  return <CSSIcon className="sale-info-icon" {...props} />;
};
export const ServiceInfoIcon = props => {
  return <CSSIcon className="service-info-icon" {...props} />;
};
export const CarserIcon = props => {
  return <CSSIcon className="carser-icon" {...props} />;
};
export const DragIcon = props => {
  return <CSSIcon className="drag-icon" {...props} />;
};
export const ThreedotsIcon = props => {
  return <CSSIcon className="threedots-icon" {...props} />;
};
export const EditIcon = props => {
  return <CSSIcon className="edit-icon" {...props} />;
};
export const HideIcon = props => {
  return <CSSIcon className="hide-icon" {...props} />;
};
export const SettingIcon = props => {
  return <CSSIcon className="setting-icon" {...props} />;
};
export const PrintIcon = props => {
  return <CSSIcon className="print-icon" {...props} />;
};
export const ShareIcon = props => {
  return <CSSIcon className="share-icon" {...props} />;
};
export const DownloadIcon = props => {
  return <CSSIcon className="download-icon" {...props} />;
};
export const ViewIcon = props => {
  return <CSSIcon className="view-icon" {...props} />;
};
export const CalendarIcon = props => {
  return <CSSIcon className="calendar-icon" {...props} />;
};
export const LocationIcon = props => {
  return <CSSIcon className="location-icon" {...props} />;
};

export const ExtLinkIcon = props => {
  return <CSSIcon className="ext-link-icon" {...props} />;
};

export const MobilePreviewIcon = props => {
  const { width = 15, height = 20, color = 'currentColor', ...rest } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M5.50154 15.2538C5.089 15.2538 4.75457 15.5882 4.75457 16.0008C4.75457 16.4133 5.089 16.7477 5.50154 16.7477H9.50154C9.91407 16.7477 10.2485 16.4133 10.2485 16.0008C10.2485 15.5882 9.91407 15.2538 9.50154 15.2538H5.50154Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4992 0.253418C13.0163 0.253418 14.2461 1.48328 14.2461 3.00038V17.0004C14.2461 18.5175 13.0163 19.7473 11.4992 19.7473H3.49916C1.98206 19.7473 0.752197 18.5175 0.752197 17.0004V3.00038C0.752197 1.48328 1.98206 0.253418 3.49916 0.253418H11.4992ZM2.24613 3.00038C2.24613 2.30835 2.80713 1.74735 3.49916 1.74735H11.4992C12.1912 1.74735 12.7522 2.30835 12.7522 3.00038V17.0004C12.7522 17.6924 12.1912 18.2534 11.4992 18.2534H3.49916C2.80713 18.2534 2.24613 17.6924 2.24613 17.0004V3.00038Z"
        fill={color}
      />
    </svg>
  );
};

export const DesktopPreviewIcon = props => {
  const { width = 21, height = 18, color = 'currentColor', ...rest } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.48716 0.248047C1.97453 0.248047 0.748291 1.47428 0.748291 2.98692V12.0085C0.748291 13.5212 1.97453 14.7474 3.48716 14.7474H17.5108C19.0235 14.7474 20.2497 13.5212 20.2497 12.0085V2.98692C20.2497 1.47428 19.0235 0.248047 17.5108 0.248047H3.48716ZM2.24222 2.98692C2.24222 2.29936 2.7996 1.74198 3.48716 1.74198H17.5108C18.1984 1.74198 18.7558 2.29936 18.7558 2.98692V12.0085C18.7558 12.6961 18.1984 13.2535 17.5108 13.2535H3.48716C2.7996 13.2535 2.24222 12.6961 2.24222 12.0085V2.98692Z"
        fill={color}
      />
      <path
        d="M5.9961 16.2563C5.58356 16.2563 5.24913 16.5908 5.24913 17.0033C5.24913 17.4158 5.58356 17.7503 5.9961 17.7503H14.9999C15.4124 17.7503 15.7468 17.4158 15.7468 17.0033C15.7468 16.5908 15.4124 16.2563 14.9999 16.2563H5.9961Z"
        fill={color}
      />
    </svg>
  );
};

export const DuplicateIcon = props => {
  const { width = 21, height = 20, color = '#1F1F1F', ...rest } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M11.2501 7.99902C11.2501 7.58481 10.9143 7.24902 10.5001 7.24902C10.0859 7.24902 9.75009 7.58481 9.75009 7.99902V9.25H8.49925C8.08504 9.25 7.74925 9.58579 7.74925 10C7.74925 10.4142 8.08504 10.75 8.49925 10.75H9.75009V12.0007C9.75009 12.4149 10.0859 12.7507 10.5001 12.7507C10.9143 12.7507 11.2501 12.4149 11.2501 12.0007V10.75H12.5009C12.9151 10.75 13.2509 10.4142 13.2509 10C13.2509 9.58579 12.9151 9.25 12.5009 9.25H11.2501V7.99902Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.746338 4.99776C0.746338 2.37363 2.87387 0.246094 5.498 0.246094H15.5022C18.1263 0.246094 20.2538 2.37363 20.2538 4.99776V13.7584C20.2538 14.7535 19.8588 15.7076 19.1558 16.4106L17.205 18.3614C16.313 19.2534 15.1048 19.7536 13.8445 19.7536H5.498C2.87387 19.7536 0.746338 17.6261 0.746338 15.0019V4.99776ZM18.7538 12.251V4.99776C18.7538 3.20205 17.2979 1.74609 15.5022 1.74609H5.498C3.7023 1.74609 2.24634 3.20205 2.24634 4.99776V15.0019C2.24634 16.7976 3.7023 18.2536 5.498 18.2536H12.7513V15.0018C12.7513 13.4821 13.9825 12.251 15.5022 12.251H18.7538ZM14.2513 18.2281V15.0018C14.2513 14.3106 14.8109 13.751 15.5022 13.751H18.7538V13.7584C18.7538 14.356 18.5166 14.9285 18.0951 15.35L16.1443 17.3008C15.6305 17.8146 14.9637 18.1383 14.2513 18.2281Z"
        fill={color}
      />
    </svg>
  );
};

export const CopyIcon = props => {
  const { width = 24, height = 24, color = 'black', ...rest } = props;
  return (
    <svg width={width} height={height} x="0px" y="0px" viewBox="0 0 1000 1000" fill="none" {...rest}>
      <path
        fill={color}
        d="M1.000002,369.468658 C2.944226,360.685822 4.397329,352.220032 6.909280,344.081085 C29.880161,269.653351 79.611046,224.458221 155.938583,208.997467 C166.783813,206.800674 178.101425,206.137100 189.202225,206.122192 C328.176208,205.935516 467.150604,205.945877 606.124817,206.018387 C695.141663,206.064835 770.214172,265.672211 790.169617,352.625702 C793.196777,365.816315 794.763306,379.638977 794.795044,393.174438 C795.123535,533.314392 795.156982,673.455627 794.942261,813.596008 C794.802185,905.038879 729.208740,982.450989 639.153137,998.140320 C633.919312,999.052185 628.611938,999.541931 623.169373,1000.614014 C472.312439,1001.000000 321.624878,1001.000000 170.307495,1000.629028 C167.211868,999.888367 164.751480,999.477295 162.279541,999.154724 C88.968094,989.589355 26.622894,935.333252 7.069537,863.921570 C4.727570,855.368347 3.008032,846.644653 0.999998,838.000000 C1.000000,681.979126 1.000000,525.958191 1.000002,369.468658 M113.504623,311.994324 C89.640175,334.316772 77.207199,361.852264 77.170494,394.490265 C77.014374,533.312378 77.062988,672.134827 77.212463,810.956970 C77.221367,819.220825 77.900757,827.679138 79.729912,835.714172 C91.935440,889.330811 135.293137,923.843628 190.565323,923.889099 C328.554260,924.002747 466.543427,923.968445 604.532288,923.815063 C612.964905,923.805664 621.587524,923.099976 629.796387,921.263794 C682.747009,909.419983 717.821472,865.645752 717.860901,811.366211 C717.962158,672.044006 717.927551,532.721619 717.789856,393.399536 C717.782715,386.127411 716.996338,378.705322 715.419067,371.609467 C703.560791,318.261719 659.494934,283.134583 604.796936,283.130219 C466.641266,283.119232 328.485565,283.143005 190.329880,283.109924 C161.335464,283.102966 135.843933,292.324005 113.504623,311.994324 z"
      />
      <path
        fill={color}
        d="M835.531372,0.999997 C845.794800,3.249386 855.830261,4.760922 865.346069,7.865549 C937.775085,31.496489 981.874634,80.744698 996.951355,155.451202 C999.238098,166.782196 999.860718,178.612122 999.877441,190.213257 C1000.071838,325.038940 999.835815,459.865295 1000.111816,594.690674 C1000.186279,631.077332 990.358582,664.389526 971.017395,694.760803 C963.025513,707.310486 953.343628,718.983032 943.207825,729.921631 C928.139587,746.183228 903.822388,746.081360 888.286560,730.824219 C872.958984,715.771484 873.039673,691.445068 888.763123,675.768738 C907.591309,656.996887 918.216370,634.207581 922.620544,608.263184 C922.952454,606.307983 922.930725,604.278381 922.930847,602.283325 C922.941040,464.624207 922.942139,326.965088 922.930847,189.305984 C922.926208,133.039581 883.853149,87.096390 828.329651,78.289680 C822.109558,77.303085 815.714478,77.079453 809.400269,77.076454 C672.407837,77.011528 535.413391,76.641197 398.424622,77.350586 C370.488708,77.495255 345.549835,88.457481 326.003326,109.466331 C312.452271,124.031212 292.712463,127.342682 276.642731,117.571922 C255.715164,104.847519 251.730240,76.904854 268.228302,58.383530 C291.166809,32.631920 319.949432,16.437834 352.819305,7.144504 C360.951599,4.845254 369.354279,3.502320 377.816345,1.359893 C530.354248,1.000000 682.708435,1.000000 835.531372,0.999997 z"
      />
    </svg>
  );
};
